<template>
  <div class="animate__animated animate__fadeIn">
    <div class="row">
      <div class="col-md-12">
        <h3 class="mb-3 text-gray-800">
          {{ $t("Vincular Usuários no Grupo") }}
          <b-link
            href="#"
            @click.prevent="void 0"
            class="mb-2"
            variant="info"
            v-b-popover.hover.top="
              'A lista abaixo vai exibir os usuários do sistema de acordo com a faixa etária do grupo'
            "
          >
            <i class="fas fa-info-circle"></i>
          </b-link>
        </h3>
      </div>
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <div>
            <a class="btn btn-default" @click="$emit('voltar')">
              <i class="mdi mdi-arrow-left" />
            </a>
          </div>
          <div>
            <div class="input-group mb-3">
              <b-input
                :placeholder="$t('Type to search')"
                class="form-control search-input"
                type="text"
                v-model="search"
                v-on:change="getUsuarios"
                aria-describedby="input-search"
              />
              <div class="input-group-append" role="button">
                <span class="input-group-text" id="input-search"
                  ><i class="fas fa-search search-icon"
                /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div>
          <a v-if="!showName" @click.prevent="mostrarNome" href="#"
            ><i class="fas fa-eye"></i> Mostrar Nome de Registro</a
          >
          <a v-else @click.prevent="ocultarNome" href="#"
            ><i class="fas fa-eye-slash"></i> Ocultar Nome de Registro</a
          >
        </div>
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />
        <b-table
          :fields="[
            {
              key: 'codigo_usuario_cadunico',
              label: $t('Detalhes do Usuário'),
            },
            {
              key: 'familia',
              label: $t('Família'),
            },
            {
              key: 'actions',
              label: '',
              class: 'text-right',
              thStyle: { width: '110px', minWidth: '110px' },
            },
          ]"
          :items="UsuarioList"
          :responsive="true"
          striped
          hover
          show-empty
          small
          outlined
          stacked="md"
          table-class="mb-3"
        >
          <template v-slot:cell(codigo_usuario_cadunico)="data">
            Nome Completo:<br />
            <b>
              <span v-if="data.item.nome_social">
                {{ data.item.nome_social }} (N.R.:)
                <span v-if="showName"> {{ data.item.nome_completo }} </span>
              </span>
              <span v-else> {{ data.item.nome_completo }} </span>
              <b-link
                :to="`/dashboard/usuario/edit/${data.item.id}`"
                target="_blank"
              >
                <i class="fas fa-external-link-alt"></i> </b-link
            ></b>
            <br />
            <div v-if="data.item.documento">
              <span v-if="data.item.documento.nis">
                NIS: <b>{{ data.item.documento.nis }} </b>
              </span>
              <span v-else>
                <span v-if="data.item.documento.cpf">
                  CPF: <b>{{ data.item.documento.cpf }}</b>
                </span>
              </span>
            </div>
            Sexo: <b v-if="data.item.sexo == 1">Masculino</b>
            <b v-if="data.item.sexo == 2">Feminino</b>
            <b v-else>Intersexo</b>
            <br />
            Idade:
            <b>{{ data.item.idade_extenso }}</b>
            <br />
            Posição Familiar:<br />
            <b>{{ data.item.posicao_familiar_nome }}</b>
            <br />
            Inscrições em outros grupos:
            <b>{{ data.item.inscricoes_scfv.length }}</b>
          </template>
          <template v-slot:cell(familia)="data">
            Código Familiar: <br />{{ data.item.familia.codigo_familiar }}
            <br />
            Responsável Familiar:<br />
            <b-link
              :to="`/dashboard/familias/edit/${data.item.familia.id}`"
              target="_blank"
              v-if="data.item.familia.responsavel_familiar"
            >
              <span v-if="data.item.familia.responsavel_familiar.nome_social">
                {{ data.item.familia.responsavel_familiar.nome_social }} (N.R.:)
                <span v-if="showName">
                  {{ data.item.familia.responsavel_familiar.nome_completo }}
                </span>
              </span>
              <span v-else>{{
                data.item.familia.responsavel_familiar.nome_completo
              }}</span>

              <i class="fas fa-external-link-alt"></i>
            </b-link>
          </template>
          <template v-slot:cell()="data">
            <b-button
              :title="$t('Usuário Inscrito neste grupo')"
              class="px-2 mb-0"
              size="xs"
              type="button"
              v-b-tooltip.hover
              variant="success"
              disabled
              v-if="verificaInscricao(data.item.inscricoes_scfv, data.item.id)"
            >
              <i class="far fa-check-circle"></i>
            </b-button>
            <b-button
              :title="$t('Vincular Usuário')"
              @click.prevent="usuarioSelecionado(data.item)"
              class="px-2 mb-0"
              size="xs"
              type="button"
              v-b-tooltip.hover
              variant="primary"
              v-else
              ><i class="fas fa-link"></i>
              Vincular
            </b-button>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />
              <h3 class="bold">{{ $t("No records found") }}</h3>
            </div>
          </template>
        </b-table>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="getUsuarios"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }} {{ pagination.currentPage }}
              {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalAdd :usuario="usuario" />
  </div>
</template>
<script>
import ModalAdd from "./ModalAdd";
export default {
  props: ["faixa_etaria"],
  name: "AddVinculo",
  components: {
    ModalAdd,
  },
  data() {
    return {
      showName: false,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      UsuarioList: [],
      usuario: null,
    };
  },
  mounted() {
    this.getUsuarios();
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    verificaInscricao(inscricoes, id) {
      var result = false;
      const map = inscricoes.map((elem) => {
        if (
          elem.scfv_grupo_id == this.$route.params.id &&
          elem.usuario_id == id
        ) {
          result = true;
        }
      });

      return result;
    },
    usuarioSelecionado(usuario) {
      this.usuario = usuario;
      this.$bvModal.show("modalVincular");
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getUsuarios();
      }
    },
    getUsuarios() {
      this.loading = true;

      axios
        .get("api/dashboard/faixaetaria/usuarios", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            faixaEtaria: this.faixa_etaria,
            scfvGrupoId: this.$route.params.id,
          },
        })
        .then((response) => {
          this.UsuarioList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getUsuarios();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
